import React, { useState } from 'react';
import './EvaluationRate.scss';

function EvaluationRate({ setValue, getValues, objectiveId, userId }) {
  const [activeButton, setActiveButton] = useState(null);

  const getScore = (clickedButton) => {
    if (clickedButton === 'acquired') return 3;
    if (clickedButton === 'development') return 2;
    return 1;
  };

  const handleButtonClick = (e, buttonName) => {
    e.preventDefault();
    const previousValue = getValues(`${objectiveId}-${userId}`);
    setValue(`${objectiveId}-${userId}`, {
      ...previousValue,
      objectiveId,
      userId,
      score: getScore(buttonName),
    })
    setActiveButton(buttonName);
  };

  return (
    <div className="eval-rate">
      <div className="eval-to-acquire">
        <button
          className={activeButton === 'acquire' || getValues(`${objectiveId}-${userId}`)?.score === 1 ? 'active' : ''}
          onClick={(e) => handleButtonClick(e, 'acquire')}
        >
          To Acquire
        </button>
      </div>
      <div className="eval-under-development">
        <button
          className={activeButton === 'development' || getValues(`${objectiveId}-${userId}`)?.score === 2 ? 'active' : ''}
          onClick={(e) => handleButtonClick(e, 'development')}
        >
          Under Development
        </button>
      </div>
      <div className="eval-acquired">
        <button
          className={activeButton === 'acquired' || getValues(`${objectiveId}-${userId}`)?.score === 3 ? 'active' : ''}
          onClick={(e) => handleButtonClick(e, 'acquired')}
        >
          Acquired
        </button>
      </div>
    </div>
  );
}

export default EvaluationRate;
